import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './auth/msalConfig';

function Login({ onLogin }) {
    const { instance, accounts } = useMsal();
    const [error, setError] = useState('');
    const [signedInEmail, setSignedInEmail] = useState('');

    const handleLogin = async () => {
        try {
            const loginResponse = await instance.loginPopup(loginRequest);
            const userEmail = loginResponse.account.username || loginResponse.account.userName;

            console.log('✅ Microsoft Login Response:', loginResponse);
            console.log('📧 Signed in as:', userEmail);

            if (userEmail.toLowerCase() === 'admin@oppies.nz') {
                localStorage.setItem('isAdmin', 'true');
                setSignedInEmail(userEmail);
                onLogin();
            } else {
                setError(`Access denied for ${userEmail}.`);
            }
        } catch (err) {
            console.error('❌ Login failed:', err);
            setError(`Login failed: ${err.message || 'Unknown error'}`);
        }

    };

    useEffect(() => {
        if (accounts.length > 0) {
            const userEmail = accounts[0].username || accounts[0].userName;
            console.log('🔁 Already signed in as:', userEmail);

            if (userEmail.toLowerCase() === 'admin@oppies.nz') {
                localStorage.setItem('isAdmin', 'true');
                setSignedInEmail(userEmail);
                onLogin();
            } else {
                setError(`Access denied for ${userEmail}.`);
            }
        }
    }, [accounts, onLogin]);

    return (
        <div className="login-container">
            <h2>Admin Login</h2>
            <button onClick={handleLogin}>Sign in with Microsoft</button>
            {signedInEmail && <p>Signed in as: <strong>{signedInEmail}</strong></p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
}

export default Login;

